export default __webpack_public_path__ + "static/media/1_1_logo.a3f04994.png";